import type { AskResponse, NotebookChapterSpec } from '../../types';
import { chapterHasVisuals, coerceChapter, tablePaints } from '../assistant/coerceChapter';
import type { NotebookChapterRecord } from '../assistant/dashboardTypes';
import type { ThreadAssistantMessage, ThreadMessage } from './threadTypes';

/** The card of an answer: the server chapter, or the bare chart/tables of an
 *  older response. The answer text lives on the message, not on the card. */
export function cardFromResponse(res: AskResponse): NotebookChapterSpec | undefined {
  if (res.chapter) {
    const spec = coerceChapter(res.chapter);
    if (chapterHasVisuals(spec)) {
      const card = { ...spec };
      delete card.story;
      return card;
    }
  }
  const chart = res.chart?.data?.length ? res.chart : null;
  const tables = (res.tables ?? []).filter(tablePaints);
  if (!chart && tables.length === 0) return undefined;
  return {
    template: 'analysis',
    windowLabel: '',
    start: '',
    end: '',
    ...(chart ? { charts: [chart] } : {}),
    ...(tables.length ? { tables } : {}),
  };
}

export type CardMessage = ThreadAssistantMessage & { card: NotebookChapterSpec };

export function cardMessages(messages: ThreadMessage[]): CardMessage[] {
  return messages.filter(
    (m): m is CardMessage => m.role === 'assistant' && !m.error && Boolean(m.card),
  );
}

/** Board pins and tiles still speak "chapter"; a card message is one. */
export function cardRecord(message: CardMessage, index: number): NotebookChapterRecord {
  return {
    id: message.id,
    index,
    question: message.question ?? '',
    answer: message.text,
    spec: message.card,
    createdAt: message.createdAt,
  };
}
